<div class="modal-header">
    <h4>{{ 'PLANT_MANAGER.AddAnItem' | transloco }}</h4>
    <a class="close-icon" href="javascript:void()" (click)="closeClick()" ngbAutofocus><i class="flaticon2-cross"></i></a>
</div>
<div class="modal-body output-lable new-user">
    <div class="row model-wrap">
        <div class="col-md-12" style="padding: 15px">
            <mat-radio-group [(ngModel)]="radioOptions" name="radioButtons" class="example-radio-group radio-wrap">
                <mat-radio-button class="radio-wrapper" id="radio_1" value="1" (change)="onRadioButtonChange($event)">
                    {{ 'PLANT_MANAGER.SelectExistingItem' | transloco }}</mat-radio-button
                >

                <div class="row">
                    <div class="col-md-12">
                        <input
                            type="text"
                            matInput
                            class="input-form-class"
                            name="searchInput"
                            placeholder="{{ 'PLANT_MANAGER.SearchTheTaggedItemName' | transloco }}"
                            autocomplete="off"
                            (keyup)="searchResult($event)"
                            [(ngModel)]="searchInput"
                            [disabled]="searchDisabled"
                        />

                        <div class="user_list">
                            <ng-container *ngIf="searchInput">
                                <ul #userCard>
                                    <li
                                        class="user-card"
                                        id="user-{{ i }} {{ item.namePrimary }}"
                                        *ngFor="let item of taggedItemList; let i = index"
                                        (click)="selectItem(item, i)"
                                    >
                                        <div class="user_details_sec">
                                            <p>{{ item.namePrimary }}</p>
                                        </div>
                                    </li>
                                </ul>
                            </ng-container>
                        </div>
                        <div style="margin: 0px 0px 0px 29px">
                            <div *ngIf="taggedItemList?.length <= 0 && searchInput" class="error-message">
                                {{ 'PLANT_MANAGER.NoDataMatching' | transloco }} "{{ searchInput }}"
                            </div>
                        </div>
                    </div>
                </div>
                <mat-radio-button class="radio-wrapper" id="radio_2" value="2" (change)="onRadioButtonChange($event)">{{
                    'PLANT_MANAGER.CreateNewItem' | transloco
                }}</mat-radio-button>
            </mat-radio-group>

            <div class="modal-footer">
                <button type="button" class="btn secondary-ebtn" (click)="closeClick()">{{ 'PLANT_MANAGER.Cancel' | transloco }}</button>
                <button type="button" class="btn primary-ebtn" [disabled]="!radioOptions" (click)="addClick()">{{ AddBtn }}</button>
            </div>
        </div>
    </div>
</div>
